import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type Keys =
	| 'spotlightTitle'
	| 'spotlightDesc'
	| 'spotlightButtonStartTourText'
	| 'spotlightButtonDismissText'
	| 'spotlightTitleIssueTermRefresh'
	| 'spotlightDescIssueTermRefresh';
type Messages = Record<Keys, MessageDescriptor>;
const messages: Messages = defineMessages({
	spotlightTitle: {
		id: 'issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-title',
		defaultMessage: 'Welcome to the new issue search 👋',
		description: 'Onboarding card title when users first switch to new issue navigator',
	},
	spotlightDesc: {
		id: 'issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-desc',
		defaultMessage:
			'Check out our new issue search to find, view, and action issues across your Jira site.',
		description: 'Onboarding card description when users first switch to new issue navigator',
	},
	spotlightButtonStartTourText: {
		id: 'issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-button-start-tour-text',
		defaultMessage: 'Show me',
		description:
			'Onboarding card button text to start onboarding tour when users first switch to new issue navigator',
	},
	spotlightButtonDismissText: {
		id: 'issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-button-dismiss-text',
		defaultMessage: 'No, thanks',
		description:
			'Onboarding card button text to dismiss onboarding tour when users first switch to new issue navigator',
	},
	spotlightTitleIssueTermRefresh: {
		id: 'issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-title-issue-term-refresh',
		defaultMessage: 'Welcome to the new way to search for work items 👋',
		description: 'Onboarding card title when users first switch to new issue navigator',
	},
	spotlightDescIssueTermRefresh: {
		id: 'issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-desc-issue-term-refresh',
		defaultMessage:
			'Check out our new search to find, view, and action work across your Jira site.',
		description: 'Onboarding card description when users first switch to new issue navigator',
	},
});
export default messages;
